import { render, staticRenderFns } from "./TableFilterV2.vue?vue&type=template&id=b90c6070&"
import script from "./TableFilterV2.vue?vue&type=script&lang=js&"
export * from "./TableFilterV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports